import axios from 'axios'
import { Decode } from '@/services'

const GetToken = () => {
  if (Object.prototype.hasOwnProperty.call(localStorage, 'authNSG')) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('authNSG')))
    // console.log('ONEDATA NAAAa', oneData)
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  }
}

export default {
  async GetInventoryData (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/inventory/list_inventory`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
